<template>
  <div>
    <div class="center_wrap">
      <div class="wrap_l">
        <!-- 委托信息模块start -->
        <div class="Item_list">
          <div class="weituo">
            <img src="../../assets/weituo.png" alt="" />
            <p class="tittype">{{$t('i18n_entrust_information')}}</p>
          </div>
          <el-form label-position="right" label-width="80px" size="small" :rules="entrustInfoRules" ref="entrustForm" :model="entrustInfo">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_person')">
                  <el-input
                    disabled
                    v-model="Authorization.customerContact"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_contact_number')">
                  <el-input
                    disabled
                    v-model="Authorization.customerTel"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_entrusting_company')">
                  <el-input disabled v-model="Authorization.namec"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 51px">
                <el-form-item :label="$t('i18n_pay_party')" prop="payType">
                  <el-radio-group
                    v-model="entrustInfo.payType"
                    style="width: 100%"
                  >
                    <el-radio label="PP">{{$t('i18n_domestic_payment')}}</el-radio>
                    <el-radio label="CC">{{$t('i18n_foreign_payment')}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_warehouse_received_time')" prop="inWarehouseTime">
                  <el-date-picker
                    type="date"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                    :placeholder="addPls('i18n_warehouse_received_time', 'select')"
                    v-model="entrustInfo.inWarehouseTime"
                    style="width: 100%"
                    :picker-options="pickerSetTime"
                  ></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12" style="height: 51px">
                <el-form-item :label="$t('i18n_clearance_metods')" prop="customsClearanceType">
                  <el-radio-group
                    v-model="entrustInfo.customsClearanceType"
                    style="width: 100%"
                  >
                    <el-radio label="Z">{{$t('i18n_self_clearing')}}</el-radio>
                    <el-radio label="S">{{$t('i18n_Cititran_incharges_of_double_clearing')}}</el-radio>
                  </el-radio-group>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_origin_port')" prop="inWarehouseId">
                  <el-select
                    v-model="entrustInfo.inWarehouseId"
                    filterable
                    :placeholder="addPls('i18n_origin_port', 'select')"
                    style="width: 100%"
                    @change="inWarehouseChange"
                  >
                    <el-option
                      v-for="item in cangkuLIst"
                      :key="item.id"
                      :label="item.namec"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_destination_city')" prop="toWarehouseId">
                  <el-cascader
                    style="width: 100%"
                    v-model="entrustInfo.toWarehouseId"
                    :options="WarehouseList"
                    :props="toWarehouseParams"
                    @change="toWarehouseChange"
                  ></el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item :label="$t('i18n_logistics_services')" prop="productId">
                  <el-select
                    v-model="entrustInfo.productId"
                    filterable
                    :placeholder="addPls('i18n_logistics_services', 'select')"
                    style="width: 100%"
                  >
                    <el-option
                      v-for="item in goodsTypeOptions"
                      :key="item.id"
                      :label="item.productName"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item :label="$t('i18n_Clients_tracking_number')">
                  <el-input
                    v-model="customerNo"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div style="width: 100%; margin-top: 50px; margin-left: 15px">
          <div style="width: 100%">
            <!-- <el-button style="width: 100%" @click="pathToback()">上一步</el-button> -->
          </div>
          <div style="width: 100%; margin-top: 10px">
            <el-button
              style="width: 100%; background: #5AB53C; color: #ffffff"
              @click="entrust"
            >{{$t('i18n_receive_warehouse_number')}}</el-button>
          </div>
        </div>
        <!-- 委托信息模块end -->
      </div>

      <el-dialog
        :title="$t('i18n_confirmed_enter_warehouse')"
        center
        :visible.sync="dialogTableVisible"
        width="520px"
      >
        <div class="showDalog">
          <div class="header_text">
            <div class="count_center" style="margin-right: 50px">
              <span class="cangkutit" style="color: red">
                {{inWarehouseInfo.namec}}
              </span>
              <span class="ckttext" style="margin-top: 10px">{{$t('i18n_receving_warehosue')}}</span>
            </div>
            <div class="cangkutit" style="margin-right: 50px">
              <!-- <img src="../../assets/images/setIcon.png" alt=""> -->
              <img style="height:32px;" src="../../assets/airOrder.png" alt="" />
            </div>
            <div class="count_center">
              <span class="cangkutit" style="color: red">
                {{ toWarehouseInfo.namec }}
              </span>
              <span class="ckttext" style="margin-top: 10px">{{$t('i18n_destination_city')}}</span>
            </div>
          </div>
          <div class="Qdbtn LR_center" style="margin-top: 30px">
            <div
              @click="dialogTableVisible = false"
              class="btnstyle"
              style="
                height: 35px;
                background: #ffffff;
                border: 2px solid #dcdcdc;
                border-radius: 35px;
              "
            >
              {{$t('i18n_cancel')}}
            </div>
            <div
              @click="submitOrder"
              class="btnstyle"
              style="
                border: 1px solid #5ab53c;
                font-size: 30rpx;
                background: #ff3939;
                border-color: #ff3939;
                color: #ffffff;
              "
            >
              {{$t('i18n_confirm')}}
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :visible.sync="successDialogVisi"
        width="599px"
        :modal="true"
        :close-on-click-modal="false"
      >
        <div class="count_center">
          <div class="centerCoutn">
            <div style="width: 100%; text-align: center;">
              <i
                style="font-size: 55px; color: #00c300"
                class="el-icon-success animate__animated animate__bounceInDown"
              ></i>
              <p
                style="
                  font-size: 20px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #333333;
                  margin-top: 27px;
                "
              >
                {{$t('i18n_order_completed')}}
              </p>
              <p
                style="
                  font-size: 14px;
                  font-family: PingFang SC;
                  font-weight: 500;
                  color: #999999;
                  margin-top: 8px;
                "
              >
                {{$t('i18n_waiting_shipment_to_warehoused')}}
              </p>
              <div class="countText">
                <p>{{$t('i18n_warehouse_number')}}：{{ orderInfo.innos }}</p>
                <!-- <p>
                  收货人：<span>{{ sendFeeForAir.name }}</span>
                  <span style="margin-left: 10px">{{ sendFeeForAir.tel }}</span>
                </p>
                <p>
                  {{$t('i18n_consignee_address')}}：{{ sendFeeForAir.country }}{{ sendFeeForAir.city
                  }}{{ sendFeeForAir.address }}
                </p> -->
              </div>
            </div>
            <div class="btnWrap" style="width: 100%; margin-top: 44px">
              <div class="LR_center" style="width: 458px">
                <div class="btn1" @click="pathBilltab()">{{$t('i18n_track_order')}}</div>
                <div class="btn2" @click="nextSetbill()">{{$t('i18n_continue_to_order')}}</div>
                <div class="btn2" @click="labelDownload()">{{$t('i18n_download_labels')}}</div>
                <!-- <div class="btn2" @click="nextSetbill()">入仓单下单</div> -->
                <!-- <div class="btn2" @click="nextSetbill()">下载入仓单</div> -->
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>
<script>
import qs from "qs";
import feeDetail from "./component/fee-detail.vue";
import { addPls } from '@/utils/placeholderI18n.js'
export default {
  data() {
    return {
      Authorization: {
        ...JSON.parse(sessionStorage.getItem("Authorization"))
      },
      pickerSetTime: {
        disabledDate(time) {
          if (localStorage.getItem("todoorTime")) {
            return time.getTime() < Date.now();
          } else {
            return time.getTime() < Date.now() - 8.64e7;
          }
        },
      },
      entrustInfo: { // 委托信息
        payType: '',
        inWarehouseId: '',
        inWarehouseTime: '',
        toWarehouseId: '',
        orderType: 3,
        customsClearanceType: '',
        productId: ''
      },
      WarehouseList: [],
      toWarehouseParams: {
        label: "namec",
        value: "id",
        children: "children"
      },
      cangkuLIst: [],
      entrustInfoRules: {
        payType: [{ required: true, message: this.addPls('i18n_pay_party', 'select'), trigger: 'change' }],
        inWarehouseTime: [{ required: true, message: this.addPls('i18n_warehouse_received_time', 'select'), trigger: 'change' }],
        inWarehouseId: [{ required: true, message: this.addPls('i18n_origin_port', 'select'), trigger: 'change' }],
        toWarehouseId: [{ required: true, message: this.addPls('i18n_destination_city', 'select'), trigger: 'change' }],
        customsClearanceType: [{ required: true, message: this.addPls('i18n_clearance_metods', 'select'), trigger: 'change' }],
        productId: [{ required: true, message: this.addPls('i18n_logistics_services', 'select'), trigger: 'change' }]
      },
      dialogTableVisible: false,
      cangkuitem: {}, // 入仓仓库信息
      PScangkuitem: {}, // 目的城市信息
      successDialogVisi: false,
      orderInfo: {}, // 订单提交成功后返回的信息
      inWarehouseInfo: {}, // 启运地仓库信息
      toWarehouseInfo: {}, // 目的城市信息
      goodsTypeOptions: [],
      customerNo: ''
    }
  },
  computed: {
  },
  created() {
    if (localStorage.getItem("pickFeeForAir")) {
      this.pickFeeForAir = JSON.parse(localStorage.getItem("pickFeeForAir"));
    }
    if (localStorage.getItem("cangkuitem")) {
      this.cangkuitem = JSON.parse(localStorage.getItem("cangkuitem"))
    }
    if (localStorage.getItem("PScangkuitem")) {
      this.PScangkuitem = JSON.parse(localStorage.getItem("PScangkuitem"))
    }
    if (sessionStorage.getItem('Authorization')) {
      this.entrustInfo.payType = JSON.parse(localStorage.getItem('Authorization')).settlementType
    }
    // this.entrustInfo.inWarehouseId = this.cangkuitem.id
    // this.entrustInfo.toWarehouseId = this.PScangkuitem.id
  },
  mounted() {
    this.getCangku()
    this.getWarehouse()
  },
  methods: {
    getCangku() {
      //获取仓库
      this.axios
        .get("/warehouse/warehouseListAir")
        .then((res) => {
          this.cangkuLIst = res.data.datas;
        })
        .catch((res) => {});
    },
    getWarehouse() {
      this.axios
        .get("/filedata/listLevelPodCity?busType=KY")
        .then((res) => {
          this.WarehouseList = res.data.datas
        })
        .catch((res) => {});
    },
    entrust() {
      this.$refs.entrustForm.validate((valid) => {
        if (valid) {
          this.dialogTableVisible = true
          return false
        } else {
          this.scrollToFalse()
        }
      })
    },
    scrollToFalse() {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName("is-error")
        isError[0].scrollIntoView({
          block: "center",
          behavior: "smooth",
        })
      })
    },
    submitOrder() { // 提交订单
      let params = {
        ...this.entrustInfo,
        customerId: this.Authorization.customerid,
        customerNo: this.customerNo,
        source: 'I',
      }
      params.toWarehouseId = params.toWarehouseId[1]
      this.axios.post('/busKY/createKYJobsBefore', params).then(res => {
        if (res.data.code === 200) {
          this.orderInfo = res.data.data
          this.successDialogVisi = true
        } else {
          this.$message.error(res.data.message)
        }
      }).catch(err => {
        this.$message.error(err)
      })
      this.dialogTableVisible = false
    },
    pathBilltab() { // 查看订单详情
      this.$router.push({
        name: "AirOrderDetail",
        query: {
          nos: this.orderInfo.innos,
          state: '1'
        }
      })
    },
    nextSetbill() { // 继续下单
      this.successDialogVisi = false
      this.$router.push('/index/placeOrder/placeIndex')
    },
    labelDownload () {
      this.axios.get(`/busKY/downKYOrderLabel/${this.orderInfo.innos}`).then(res => {
        window.open(res.data.data)
      })
    },
    inWarehouseChange(id) {
      this.cangkuLIst.forEach(item => {
        if (item.id === id) {
          this.inWarehouseInfo = item
        }
      })
      this.getGoodsTypeList()
    },
    toWarehouseChange(toWarehouseId) {
      this.WarehouseList.forEach(item => {
        item.children.forEach(city => {
          if (city.id === toWarehouseId[1]) {
            this.toWarehouseInfo = city
          }
        })
      })
      this.getGoodsTypeList()
    },
    getGoodsTypeList() {
      if (this.entrustInfo.inWarehouseId && this.entrustInfo.toWarehouseId) {
        this.axios.get(`/filedata/findKYDatGoodsSetInfoDTOList?polLandid=${this.entrustInfo.inWarehouseId}&podLandid=${this.entrustInfo.toWarehouseId[1]}`).then(res => {
          this.entrustInfo.productId = ''
          this.goodsTypeOptions = res.data.datas
        })
      }
    },
    addPls
  }
}
</script>
<style lang="scss" scoped>
.center_wrap {
  display: flex;
  display: -webkit-flex;
  width: 1098px;
  margin: 0 auto;
}
.Item_list {
  width: 100%;
  padding: 24px 28px 12px 28px;
  box-sizing: border-box;
  box-shadow: 0px 0px 20px 0px rgba(193, 193, 193, 0.21);
  border-radius: 25px !important;
  margin: 15px 15px;
}
.wrap_l {
  float: left;
  width: 1100px;
  background: #ffffff;
  box-sizing: border-box;
  padding-bottom: 50px;
  margin: 0 auto;
}
.tittype {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
  margin-left: 10px;
}
.weituo {
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
}
.el-checkbox-group {
  display: flex;
  flex-direction: column;
}
/deep/ .el-form-item__label {
  color: rgb(153, 153, 153) !important;
  font-family: Helvetica, "San Francisco", "Microsoft Yahei", 微软雅黑, "Heiti SC";
}
.poperWrap {
  width: 100%;
  height: 40px;
  border: 1px solid #e6e6e6;
  padding: 13px;
  box-sizing: border-box;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  flex-flow: row nowrap;
  justify-content: space-between;
  cursor: pointer;
  transition: all 0.4s;
}
.poperWrap:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  transform: scale(1.02);
}
.dialog >>> .el-dialog__body {
  padding: 0px 30px 30px 30px !important;
}
.dialog >>> .el-dialog__header {
  padding: 10px !important;
}
.header_text {
  text-align: center;
  width: 100%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .ckttext {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #9a9a9a;
  }
  .cangkutit {
    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #343434;
    float: left;
  }
}
.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  /* column垂直 */
  flex-direction: column;
}
.Qdbtn {
  width: 100%;
  padding: 0 60px;
  box-sizing: border-box;
}
.LR_center {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
}
.btnstyle {
  width: 150px;
  height: 35px;
  background: #ffffff;
  border: 2px solid #dcdcdc;
  border-radius: 35px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.centerCoutn {
  width: 100%;
}
.countText {
  padding-top: 31px;
  width: 385px;
  margin: 0 auto;
  box-sizing: border-box;
  p {
    margin-bottom: 10px;
    padding: 0 auto;
    font-size: 16px;
    font-weight: bold;
  }
}
.btnWrap {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  .LR_center {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    div {
      width: 135px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #5AB53C;
      border-radius: 5px;
      display: flex;
      display: -webkit-flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #5AB53C;
      cursor: pointer;
      &:nth-child(2) {
        background: #5AB53C;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/airOrder/getAirWarehouseNo.vue